import {
  HTTP_DEPARTMENTSPECIAL_FETCHING,
  HTTP_DEPARTMENTSPECIAL_SUCCESS,
  HTTP_DEPARTMENTSPECIAL_FAILED,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
//   import { async } from "q";

export const setStateDepartmentSpecialToFetching = () => ({
  type: HTTP_DEPARTMENTSPECIAL_FETCHING,
});

export const setStateDepartmentSpecialToSuccess = (payload) => ({
  type: HTTP_DEPARTMENTSPECIAL_SUCCESS,
  payload,
});

export const setStateDepartmentSpecialToFailed = (payload) => ({
  type: HTTP_DEPARTMENTSPECIAL_FAILED,
});

export const getDeptsSpecial = (brandid) => {
  // console.log(countryid);
  return async (dispatch) => {
    dispatch(setStateDepartmentSpecialToFetching());

    try {
      const result = await httpClient.get(
        `${server.DEPARTSPECIAL_URL}/${brandid}`
      );
      dispatch(setStateDepartmentSpecialToSuccess(result.data));
    } catch (error) {
      dispatch(setStateDepartmentSpecialToFailed());
    }
  };
};
